import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 bg-white ${
      scrolled ? 'shadow-sm' : ''
    }`}>
      {/* Slim gold top accent line */}
      <div className={`absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#C9A96E] to-transparent transition-opacity duration-500 ${
        scrolled ? 'opacity-60' : 'opacity-30'
      }`}></div>

      <div className="max-w-[1400px] mx-auto px-12">
        <div className="flex items-center justify-between h-[88px]">
          {/* Logo */}
          <Link to="/" className="flex items-center relative z-10">
            <img 
              src="https://static.readdy.ai/image/f30444846e2254d95b405efc135ce378/deea87c36f9c2a3377548eebefcbfbbb.png" 
              alt="Diivy Medical Technology" 
              className="h-11 w-auto object-contain"
            />
          </Link>

          {/* Center Navigation */}
          <div className="hidden md:flex items-center gap-14">
            <Link to="/about" className="text-[13px] font-medium text-gray-700 hover:text-[#C9A96E] transition-colors duration-400 whitespace-nowrap tracking-wide">
              About
            </Link>
            <Link to="/diitect" className="text-[13px] font-medium text-gray-700 hover:text-[#C9A96E] transition-colors duration-400 whitespace-nowrap tracking-wide">
              Diitect
            </Link>
            <Link to="/vetuvia" className="text-[13px] font-medium text-gray-700 hover:text-[#C9A96E] transition-colors duration-400 whitespace-nowrap tracking-wide">
              Vetuvia
            </Link>
            <Link to="/world-cup" className="text-[13px] font-medium text-gray-700 hover:text-[#C9A96E] transition-colors duration-400 whitespace-nowrap tracking-wide">
              World Cup
            </Link>
            <Link to="/tire-technology" className="text-[13px] font-medium text-gray-700 hover:text-[#C9A96E] transition-colors duration-400 whitespace-nowrap tracking-wide">
              Tire Technology
            </Link>
            <Link to="/contact" className="text-[13px] font-medium text-gray-700 hover:text-[#C9A96E] transition-colors duration-400 whitespace-nowrap tracking-wide">
              Contact
            </Link>
          </div>

          {/* Right CTA - Pill Style */}
          <Link 
            to="/contact"
            className="hidden md:block px-7 py-2.5 bg-transparent border border-[#C9A96E]/40 text-[13px] font-medium text-[#C9A96E] rounded-full hover:bg-[#C9A96E] hover:text-white hover:border-[#C9A96E] transition-all duration-400 whitespace-nowrap tracking-wide"
          >
            Investor Inquiry
          </Link>
        </div>
      </div>
    </nav>
  );
}
